<div class="g-layout__container" [attr.dir]="dir">
  <div class="profile-header">
    <button type="button" class="back-btn" (click)="goBack()">
      @if (dir == 'rtl') {
        <i class="fa-solid fa-arrow-right"></i>
      } @else {
        <i class="fa-solid fa-arrow-left"></i>
      }
    </button>
    <div class="header-title">
      <i class="fa-solid fa-user-circle"></i>
      <span>{{ 'Profile' | navTitle | async }}</span>
    </div>
  </div>

  <div class="profile-card">
    <div class="avatar-section">
      <div class="avatar-circle">
        <i class="fa-solid fa-user"></i>
      </div>
      <div class="user-title">
        <h2>{{ user?.name }}</h2>
        <p class="role-badge">
          <i class="fa-solid fa-shield-halved"></i>
          {{ user?.role_name }}
        </p>
      </div>
    </div>

    <div class="profile-info-grid">
      <div class="info-field">
        <label class="info-label">
          <i class="fa-solid fa-user"></i>
          <span>{{ 'name' | translate }}</span>
        </label>
        <div class="info-value-wrapper">
          <input type="text" pInputText [ngModel]="user?.name" readonly class="info-input" />
        </div>
      </div>

      <div class="info-field">
        <label class="info-label">
          <i class="fa-solid fa-at"></i>
          <span>{{ 'username' | translate }}</span>
        </label>
        <div class="info-value-wrapper">
          <input type="text" pInputText [ngModel]="user?.username" readonly class="info-input" />
        </div>
      </div>

      <div class="info-field">
        <label class="info-label">
          <i class="fa-solid fa-envelope"></i>
          <span>{{ 'email' | translate }}</span>
        </label>
        <div class="info-value-wrapper">
          <input type="email" pInputText [ngModel]="user?.email" readonly class="info-input" />
        </div>
      </div>

      @if (user?.role?.toString() != 'senior_admin' && user?.is_in_department) {
        <div class="info-field">
          <label class="info-label">
            <i class="fa-solid fa-building"></i>
            <span>{{ 'user_department' | translate }}</span>
          </label>
          <div class="info-value-wrapper">
            <input type="text" pInputText [ngModel]="user?.department_name" readonly class="info-input" />
          </div>
        </div>
      }

      @if (user?.role?.toString() != 'senior_admin' && user?.is_in_section) {
        <div class="info-field">
          <label class="info-label">
            <i class="fa-solid fa-sitemap"></i>
            <span>{{ 'user_section' | translate }}</span>
          </label>
          <div class="info-value-wrapper">
            <input type="text" pInputText [ngModel]="user?.section_name" readonly class="info-input" />
          </div>
        </div>
      }

      <div class="info-field">
        <label class="info-label">
          <i class="fa-solid fa-user-shield"></i>
          <span>{{ 'user_role' | translate }}</span>
        </label>
        <div class="info-value-wrapper">
          <input type="text" pInputText [ngModel]="user?.role_name" readonly class="info-input" />
        </div>
      </div>

      @if (user?.job_title) {
        <div class="info-field">
          <label class="info-label">
            <i class="fa-solid fa-briefcase"></i>
            <span>{{ 'job_title' | translate }}</span>
          </label>
          <div class="info-value-wrapper">
            <input type="text" pInputText [ngModel]="user?.job_title" readonly class="info-input" />
          </div>
        </div>
      }
    </div>

    <div class="action-buttons">
      <button type="button" class="action-btn edit-profile-btn" (click)="openEditModal()">
        <i class="fa-solid fa-pen-to-square"></i>
        <span>{{ 'edit_profile' | translate }}</span>
      </button>
      <button type="button" class="action-btn change-password-btn" (click)="openPasswordModal()">
        <i class="fa-solid fa-key"></i>
        <span>{{ 'change_password' | translate }}</span>
      </button>
    </div>
  </div>
</div>

@if (isEditModalVisible) {
  <div class="modal-wrapper">
    <div class="g-overlay" (click)="closeEditModal()"></div>
    <div class="g-modal">
      <div class="modal-header">
        <div class="modal-title">{{ 'edit_profile' | translate }}</div>
        <button type="button" class="close-btn" (click)="closeEditModal()">
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>
      <div class="modal-body">
        <form [formGroup]="profileForm" (ngSubmit)="submitProfile()">
          <div class="form-control">
            <label class="form-label">
              <i class="fa-solid fa-user"></i>
              {{ 'name' | translate }}
            </label>
            <input type="text" pInputText formControlName="name" />
            @if (profileForm.get('name')?.invalid && profileForm.get('name')?.touched) {
              <small class="error-message">{{ 'field_is_required' | translate }}</small>
            }
          </div>

          <div class="form-control">
            <label class="form-label">
              <i class="fa-solid fa-envelope"></i>
              {{ 'email' | translate }}
            </label>
            <input type="email" pInputText formControlName="email" />
            @if (profileForm.get('email')?.invalid && profileForm.get('email')?.touched) {
              <small class="error-message">{{ 'field_is_required' | translate }}</small>
            }
          </div>

          <div class="form-control">
            <label class="form-label">
              <i class="fa-solid fa-briefcase"></i>
              {{ 'job_title' | translate }}
            </label>
            <input type="text" pInputText formControlName="job_title" />
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="cancel-btn" (click)="closeEditModal()" [disabled]="isSubmitting">
          {{ 'cancel' | translate }}
        </button>
        <button type="button" class="save-btn" (click)="submitProfile()" [disabled]="isSubmitting">
          @if (isSubmitting) {
            <i class="fa-solid fa-spinner fa-spin"></i>
          } @else {
            <i class="fa-solid fa-check"></i>
          }
          {{ 'save' | translate }}
        </button>
      </div>
    </div>
  </div>
}

@if (isPasswordModalVisible) {
  <div class="modal-wrapper">
    <div class="g-overlay" (click)="closePasswordModal()"></div>
    <div class="g-modal">
      <div class="modal-header">
        <div class="modal-title">{{ 'change_password' | translate }}</div>
        <button type="button" class="close-btn" (click)="closePasswordModal()">
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>
      <div class="modal-body">
        <form [formGroup]="passwordForm" (ngSubmit)="submitPassword()">
          <div class="form-control">
            <label class="form-label">
              <i class="fa-solid fa-lock"></i>
              {{ dir === 'rtl' ? 'كلمة المرور الحالية' : 'Current password' }}
            </label>
            <div class="password-field">
              <input [type]="currentPasswordFieldType" pInputText formControlName="current_password" autocomplete="current-password" />
              <button type="button" class="eye-btn" (click)="togglePasswordVisibility('current')">
                <i class="fa-solid" [ngClass]="currentPasswordFieldType === 'password' ? 'fa-eye-slash' : 'fa-eye'"></i>
              </button>
            </div>
            @if (passwordForm.get('current_password')?.invalid && passwordForm.get('current_password')?.touched) {
              <small class="error-message">{{ 'field_is_required' | translate }}</small>
            }
          </div>

          <div class="form-control">
            <label class="form-label">
              <i class="fa-solid fa-key"></i>
              {{ dir === 'rtl' ? 'كلمة المرور الجديدة' : 'New password' }}
            </label>
            <div class="password-field">
              <input [type]="newPasswordFieldType" pInputText formControlName="new_password" autocomplete="new-password" />
              <button type="button" class="eye-btn" (click)="togglePasswordVisibility('new')">
                <i class="fa-solid" [ngClass]="newPasswordFieldType === 'password' ? 'fa-eye-slash' : 'fa-eye'"></i>
              </button>
            </div>
            @if (passwordForm.get('new_password')?.invalid && passwordForm.get('new_password')?.touched) {
              <small class="error-message">
                {{ dir === 'rtl' ? '6 أحرف على الأقل' : 'At least 6 characters' }}
              </small>
            }
          </div>

          <div class="form-control">
            <label class="form-label">
              <i class="fa-solid fa-key"></i>
              {{ dir === 'rtl' ? 'تأكيد كلمة المرور' : 'Confirm password' }}
            </label>
            <div class="password-field">
              <input [type]="confirmPasswordFieldType" pInputText formControlName="confirm_password" autocomplete="new-password" />
              <button type="button" class="eye-btn" (click)="togglePasswordVisibility('confirm')">
                <i class="fa-solid" [ngClass]="confirmPasswordFieldType === 'password' ? 'fa-eye-slash' : 'fa-eye'"></i>
              </button>
            </div>
            @if (passwordForm.get('confirm_password')?.invalid && passwordForm.get('confirm_password')?.touched) {
              <small class="error-message">{{ 'field_is_required' | translate }}</small>
            }
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="cancel-btn" (click)="closePasswordModal()" [disabled]="isPasswordSubmitting">
          {{ 'cancel' | translate }}
        </button>
        <button type="button" class="save-btn" (click)="submitPassword()" [disabled]="isPasswordSubmitting">
          @if (isPasswordSubmitting) {
            <i class="fa-solid fa-spinner fa-spin"></i>
          } @else {
            <i class="fa-solid fa-check"></i>
          }
          {{ 'save' | translate }}
        </button>
      </div>
    </div>
  </div>
}
